//UI Material
import { Card, Grid } from "@mui/material";

//Local components
import ElementCard from "../ProComponents/ElementCard";

//Material Icons
import { ArrowForwardIos } from "@mui/icons-material";

export default function CustomerService() {
  const sections = [
    {
      title: "Historial de Cotizaciones",
      titleVariant: "body1",
      details: [
        "Visualiza todas las cotizaciones generadas en el sistema con sus detalles completos, permitiendo realizar búsquedas y seguimientos de forma rápida.",
      ],
      bottomActions: [
        { text: "VER SECCIÓN", href: "/quotes", endIcon: <ArrowForwardIos /> },
      ],
    },
    {
      title: "Creador de Cotizaciones",
      titleVariant: "body1",
      details: [
        "Genera nuevas cotizaciones de manera ágil, personalizando los productos o servicios según las necesidades del cliente.",
      ],
      bottomActions: [
        {
          text: "VER SECCIÓN",
          href: "/new-quote",
          endIcon: <ArrowForwardIos />,
        },
      ],
    },
    {
      title: "Registro de Clientes",
      titleVariant: "body1",
      details: [
        "Consulta y administra todos los clientes registrados en la plataforma, con acceso rápido a su información y antecedentes comerciales.",
      ],
      bottomActions: [
        { text: "VER SECCIÓN", href: "/clients", endIcon: <ArrowForwardIos /> },
      ],
    },
  ];

  return (
    <Grid container spacing={2} p={2}>
      <Grid item xs={12}>
        <ElementCard
          ops={{
            title: "Servicio al Cliente",
            details: [
              "Aquí podrá encontrar todas las secciones para la gestión del servicio al cliente",
            ],
          }}
        />
      </Grid>
      {sections.map((section) => (
        <Grid key={section.title} item xs={12} md={6}>
          <Card raised sx={{ p: 2 }}>
            <ElementCard ops={section} />
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}
